import { Toolbar } from '@box/blueprint-web';
import type { Editor } from '@tiptap/react';
import React, { useRef } from 'react';
import '../../styles.scss';
import { AlignmentPopover } from './components/alignment-popover';
import { FontColorPicker } from './components/font-color-picker';
import { FontSizeDropdown } from './components/font-size-dropdown';
import { FontStyleList } from './components/font-style-list';
import { HyperlinkSetting } from './components/hyperlink-setting';
import { ListStylesToggleGroup } from './components/list-styles-toggle-group';

type BlueprintTextEditorToolbarProps = {
  editor: Editor | null;
};

export const BlueprintTextEditorToolbar =
  React.memo<BlueprintTextEditorToolbarProps>(
    ({ editor }: BlueprintTextEditorToolbarProps) => {
      const containerRef = useRef(null);

      if (!editor) return null;

      return (
        <Toolbar.Root ref={containerRef} className="toolbarRoot">
          <FontColorPicker editor={editor} />
          <Toolbar.Separator />
          <FontSizeDropdown editor={editor} containerRef={containerRef} />
          <Toolbar.Separator />
          <FontStyleList editor={editor} />
          <Toolbar.Separator />
          <HyperlinkSetting editor={editor} />
          <Toolbar.Separator />
          <AlignmentPopover editor={editor} containerRef={containerRef} />
          <Toolbar.Separator />
          <ListStylesToggleGroup editor={editor} />
        </Toolbar.Root>
      );
    },
  );
